import find from 'lodash/find'
import map from 'lodash/map'
import trim from 'lodash/trim'
import { getPlayerId, getPlayerRegion } from '@/utils/player'

export default {
  props: {
    id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      player: null,
      regionPlayers: []
    }
  },
  computed: {
    providers () {
      if(this.player.provider)
        return map(this.player.provider.split(';'), title => trim(title))
      return ``
    },
    career () {
      if(this.player.career)
        return map(this.player.career.split(';'), title => trim(title))
      return ``
    },
    secrecy_jurisdictions () {
      if(this.player.other_countries)
        return map(this.player.other_countries.split(','), c => trim(c).toLowerCase())
      return ``
    },
    embedUrl () {
      return this.getFullUrl(this.$router.resolve({ name: 'player.profile.embed' }).href)
    },
    sharingOptionsValues () {
      return {
        "url": this.embedUrl
      }
    }
  },
  mounted () {
    this.findPlayer()
    this.findRegionPlayers()
  },
  watch: {
    id () {
      this.findPlayer()
      this.findRegionPlayers()
    }
  },
  methods: {
    findRegionPlayers() {
      if(!this.id)
        return false
      
      const region_id = getPlayerRegion(this.$store.state.players.ordered, this.id)

      const players = find(this.$store.state.players.regions, ['region_id', region_id])

      this.$set(this, 'regionPlayers', players)
    },
    findPlayer() {
      if(!this.id)
        return false
      
      const id = getPlayerId(this.$store.state.players.ordered, this.id)

      let player = null
      if (id === 'global-overview') {
        player = { id }
      } else {
        player = find(this.$store.state.players.ordered, { id })
      }
      this.$set(this, 'player', player)
    }
  }
}
